
const state = {
    FICacheList: [],
    KICacheList: [],
    InputPlaceholder: '写下我的留言或提问...',
    InputContent: false, //是否有评论内容(包括图片)
    callCommentInput:false,
    commentInfo:null,
    toastText:'',
    callToast:false,
    commentImgList:null
}

const getters = {
    GET_FI_CACHE: (state) => {
        return state.FICacheList
    },
    GET_KI_CACHE: (state) => {
        return state.KICacheList
    },
    GET_CallCommentInput: (state) => {
        return state.callCommentInput
    },
    GET_CommentInfo: (state) => {
        return state.commentInfo
    },
    GET_InputPlaceholder: (state) => {
        return state.InputPlaceholder
    },
    GET_InputContent: (state) => {
        return state.InputContent
    },
    GET_CallToast: (state) => {
        return state.callToast
    },
    GET_ToastText: (state) => {
        return state.toastText
    },
    GET_CommentIMGList: (state) => {
        return state.commentImgList
    },

}

const mutations = {
    SET_FI_CACHE (state, faqInfo) {
        state.FICacheList.push(faqInfo)
    },
    SET_KI_CACHE (state, knowledgeInfo) {
        state.KICacheList.push(knowledgeInfo)
    },
    SET_CallCommentInput(state, callCommentInput) {
        state.callCommentInput = callCommentInput
    },
    SET_CommentInfo(state, commentInfo) {
        state.commentInfo = commentInfo
    },
    SET_InputPlaceholder(state, placeholder) {
        state.InputPlaceholder = placeholder
    },
    SET_InputContent(state, inputContent) {
        state.InputContent = inputContent
    },
    SetAndCallToast(state, toastText) {
        state.toastText = toastText
        state.callToast = true
        let timer = setTimeout(() => {
            state.callToast = false
            clearTimeout(timer);
        }, 1000)
    },

    SET_CommentIMGList(state , commentImg) {
        state.commentImgList = commentImg.sourceList
        if (commentImg.sourceList){
            let timer = setTimeout(() => {
                document.getElementById('source-image-preview').show(commentImg.index)
                clearTimeout(timer);
            }, 300)
        }
    },

}

export default {
    state,
    getters,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/detail.js